/**
 * Som curto de notificação (Web Audio API). Usado para avisar nova mensagem do
 * WhatsApp no app desktop. Falha silenciosamente onde o Web Audio não existe.
 */
export function playNotificationSound(): void {
  try {
    const Ctx =
      window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!Ctx) return;

    const audioContext = new Ctx();
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);

    // Bipe curto que sobe e desce (agradável, tipo "pop" de mensagem).
    oscillator.frequency.setValueAtTime(880, audioContext.currentTime);
    oscillator.frequency.exponentialRampToValueAtTime(620, audioContext.currentTime + 0.12);
    oscillator.frequency.exponentialRampToValueAtTime(880, audioContext.currentTime + 0.24);

    gainNode.gain.setValueAtTime(0.25, audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3);

    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + 0.3);

    // Libera o AudioContext logo depois (evita acumular contextos).
    window.setTimeout(() => {
      try {
        void audioContext.close();
      } catch {
        /* noop */
      }
    }, 600);
  } catch {
    /* navegador sem Web Audio → silencioso */
  }
}
